"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const static_colors_1 = __importDefault(require("../../global/static-colors"));
const typography_1 = __importDefault(require("./typography"));
const spacing_1 = __importDefault(require("./spacing"));
const output = {
    name: 'pricefinder-light',
    spacing: spacing_1.default,
    typography: typography_1.default,
    colors: {
        neutral: {
            heavy: {
                default: static_colors_1.default.coolGrey700,
                hover: static_colors_1.default.coolGrey800,
                pressed: static_colors_1.default.coolGrey900,
                selected: static_colors_1.default.coolGrey900,
                disabled: static_colors_1.default.coolGrey300,
            },
            medium: {
                default: static_colors_1.default.coolGrey500,
                hover: static_colors_1.default.coolGrey600,
                pressed: static_colors_1.default.coolGrey700,
                selected: static_colors_1.default.coolGrey800,
                disabled: static_colors_1.default.coolGrey300,
            },
            base: {
                default: static_colors_1.default.coolGrey300,
                hover: static_colors_1.default.coolGrey400,
                pressed: static_colors_1.default.coolGrey500,
                selected: static_colors_1.default.coolGrey800,
                disabled: static_colors_1.default.coolGrey300,
            },
            trim: {
                default: static_colors_1.default.coolGrey300,
                hover: static_colors_1.default.coolGrey400,
                pressed: static_colors_1.default.coolGrey500,
                selected: static_colors_1.default.coolGrey700,
                disabled: static_colors_1.default.coolGrey200,
            },
            subdued: {
                default: static_colors_1.default.coolGrey50,
                hover: static_colors_1.default.coolGrey100,
                pressed: static_colors_1.default.coolGrey200,
                selected: static_colors_1.default.coolGrey50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.coolGrey50,
                pressed: static_colors_1.default.coolGrey100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        interactive: {
            heavy: {
                default: static_colors_1.default.aqua800,
                hover: static_colors_1.default.aqua900,
                pressed: static_colors_1.default.aqua900,
                selected: static_colors_1.default.aqua900,
                disabled: static_colors_1.default.coolGrey300,
            },
            medium: {
                default: static_colors_1.default.aqua600,
                hover: static_colors_1.default.aqua700,
                pressed: static_colors_1.default.aqua800,
                selected: static_colors_1.default.aqua900,
                disabled: static_colors_1.default.coolGrey300,
            },
            base: {
                default: static_colors_1.default.aqua500,
                hover: static_colors_1.default.aqua600,
                pressed: static_colors_1.default.aqua700,
                selected: static_colors_1.default.aqua900,
                disabled: static_colors_1.default.coolGrey300,
            },
            trim: {
                default: static_colors_1.default.aqua300,
                hover: static_colors_1.default.aqua400,
                pressed: static_colors_1.default.aqua500,
                selected: static_colors_1.default.aqua700,
                disabled: static_colors_1.default.coolGrey300,
            },
            subdued: {
                default: static_colors_1.default.aqua50,
                hover: static_colors_1.default.aqua100,
                pressed: static_colors_1.default.aqua200,
                selected: static_colors_1.default.aqua50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.aqua50,
                pressed: static_colors_1.default.aqua100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        primary: {
            heavy: {
                default: static_colors_1.default.aqua800,
                hover: static_colors_1.default.aqua900,
                pressed: static_colors_1.default.aqua900,
                selected: static_colors_1.default.aqua900,
                disabled: static_colors_1.default.coolGrey300,
            },
            medium: {
                default: static_colors_1.default.aqua600,
                hover: static_colors_1.default.aqua700,
                pressed: static_colors_1.default.aqua800,
                selected: static_colors_1.default.aqua900,
                disabled: static_colors_1.default.coolGrey300,
            },
            base: {
                default: static_colors_1.default.aqua500,
                hover: static_colors_1.default.aqua600,
                pressed: static_colors_1.default.aqua700,
                selected: static_colors_1.default.aqua900,
                disabled: static_colors_1.default.coolGrey300,
            },
            trim: {
                default: static_colors_1.default.aqua300,
                hover: static_colors_1.default.aqua400,
                pressed: static_colors_1.default.aqua500,
                selected: static_colors_1.default.aqua700,
                disabled: static_colors_1.default.coolGrey300,
            },
            subdued: {
                default: static_colors_1.default.aqua50,
                hover: static_colors_1.default.aqua100,
                pressed: static_colors_1.default.aqua200,
                selected: static_colors_1.default.aqua50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.aqua50,
                pressed: static_colors_1.default.aqua100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        secondary: {
            heavy: {
                default: static_colors_1.default.domainBlue800,
                hover: static_colors_1.default.domainBlue900,
                pressed: static_colors_1.default.domainBlue900,
                selected: static_colors_1.default.domainBlue900,
                disabled: static_colors_1.default.coolGrey300,
            },
            medium: {
                default: static_colors_1.default.domainBlue600,
                hover: static_colors_1.default.domainBlue700,
                pressed: static_colors_1.default.domainBlue800,
                selected: static_colors_1.default.domainBlue900,
                disabled: static_colors_1.default.coolGrey300,
            },
            base: {
                default: static_colors_1.default.domainBlue500,
                hover: static_colors_1.default.domainBlue600,
                pressed: static_colors_1.default.domainBlue700,
                selected: static_colors_1.default.domainBlue900,
                disabled: static_colors_1.default.domainBlue300,
            },
            trim: {
                default: static_colors_1.default.domainBlue300,
                hover: static_colors_1.default.domainBlue400,
                pressed: static_colors_1.default.domainBlue500,
                selected: static_colors_1.default.domainBlue700,
                disabled: static_colors_1.default.coolGrey300,
            },
            subdued: {
                default: static_colors_1.default.domainBlue50,
                hover: static_colors_1.default.domainBlue100,
                pressed: static_colors_1.default.domainBlue200,
                selected: static_colors_1.default.domainBlue50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.domainBlue50,
                pressed: static_colors_1.default.domainBlue100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        info: {
            heavy: {
                default: static_colors_1.default.ocean800,
                hover: static_colors_1.default.ocean900,
                pressed: static_colors_1.default.ocean900,
                selected: static_colors_1.default.ocean900,
                disabled: static_colors_1.default.coolGrey300,
            },
            medium: {
                default: static_colors_1.default.ocean600,
                hover: static_colors_1.default.ocean700,
                pressed: static_colors_1.default.ocean800,
                selected: static_colors_1.default.ocean900,
                disabled: static_colors_1.default.coolGrey300,
            },
            base: {
                default: static_colors_1.default.ocean500,
                hover: static_colors_1.default.ocean600,
                pressed: static_colors_1.default.ocean700,
                selected: static_colors_1.default.ocean900,
                disabled: static_colors_1.default.coolGrey300,
            },
            trim: {
                default: static_colors_1.default.ocean300,
                hover: static_colors_1.default.ocean400,
                pressed: static_colors_1.default.ocean500,
                selected: static_colors_1.default.ocean700,
                disabled: static_colors_1.default.coolGrey300,
            },
            subdued: {
                default: static_colors_1.default.ocean50,
                hover: static_colors_1.default.ocean100,
                pressed: static_colors_1.default.ocean200,
                selected: static_colors_1.default.ocean50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.ocean50,
                pressed: static_colors_1.default.ocean100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        success: {
            heavy: {
                default: static_colors_1.default.aqua800,
                hover: static_colors_1.default.aqua900,
                pressed: static_colors_1.default.aqua900,
                selected: static_colors_1.default.aqua900,
                disabled: static_colors_1.default.coolGrey300,
            },
            medium: {
                default: static_colors_1.default.aqua600,
                hover: static_colors_1.default.aqua700,
                pressed: static_colors_1.default.aqua800,
                selected: static_colors_1.default.aqua900,
                disabled: static_colors_1.default.coolGrey300,
            },
            base: {
                default: static_colors_1.default.aqua500,
                hover: static_colors_1.default.aqua600,
                pressed: static_colors_1.default.aqua700,
                selected: static_colors_1.default.aqua900,
                disabled: static_colors_1.default.coolGrey300,
            },
            trim: {
                default: static_colors_1.default.aqua300,
                hover: static_colors_1.default.aqua400,
                pressed: static_colors_1.default.aqua500,
                selected: static_colors_1.default.aqua700,
                disabled: static_colors_1.default.coolGrey300,
            },
            subdued: {
                default: static_colors_1.default.aqua50,
                hover: static_colors_1.default.aqua100,
                pressed: static_colors_1.default.aqua200,
                selected: static_colors_1.default.aqua50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.aqua50,
                pressed: static_colors_1.default.aqua100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        warning: {
            heavy: {
                default: static_colors_1.default.canary800,
                hover: static_colors_1.default.canary900,
                pressed: static_colors_1.default.canary900,
                selected: static_colors_1.default.canary900,
                disabled: static_colors_1.default.coolGrey300,
            },
            medium: {
                default: static_colors_1.default.canary600,
                hover: static_colors_1.default.canary700,
                pressed: static_colors_1.default.canary800,
                selected: static_colors_1.default.canary900,
                disabled: static_colors_1.default.coolGrey300,
            },
            base: {
                default: static_colors_1.default.canary500,
                hover: static_colors_1.default.canary600,
                pressed: static_colors_1.default.canary700,
                selected: static_colors_1.default.canary900,
                disabled: static_colors_1.default.coolGrey300,
            },
            trim: {
                default: static_colors_1.default.canary300,
                hover: static_colors_1.default.canary400,
                pressed: static_colors_1.default.canary500,
                selected: static_colors_1.default.canary700,
                disabled: static_colors_1.default.coolGrey300,
            },
            subdued: {
                default: static_colors_1.default.canary50,
                hover: static_colors_1.default.canary100,
                pressed: static_colors_1.default.canary200,
                selected: static_colors_1.default.canary50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.canary50,
                pressed: static_colors_1.default.canary100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        critical: {
            heavy: {
                default: static_colors_1.default.lobster800,
                hover: static_colors_1.default.lobster900,
                pressed: static_colors_1.default.lobster900,
                selected: static_colors_1.default.lobster900,
                disabled: static_colors_1.default.coolGrey300,
            },
            medium: {
                default: static_colors_1.default.lobster600,
                hover: static_colors_1.default.lobster700,
                pressed: static_colors_1.default.lobster800,
                selected: static_colors_1.default.lobster900,
                disabled: static_colors_1.default.coolGrey300,
            },
            base: {
                default: static_colors_1.default.lobster500,
                hover: static_colors_1.default.lobster600,
                pressed: static_colors_1.default.lobster700,
                selected: static_colors_1.default.lobster900,
                disabled: static_colors_1.default.coolGrey300,
            },
            trim: {
                default: static_colors_1.default.lobster300,
                hover: static_colors_1.default.lobster400,
                pressed: static_colors_1.default.lobster500,
                selected: static_colors_1.default.lobster700,
                disabled: static_colors_1.default.coolGrey300,
            },
            subdued: {
                default: static_colors_1.default.lobster50,
                hover: static_colors_1.default.lobster100,
                pressed: static_colors_1.default.lobster200,
                selected: static_colors_1.default.lobster50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.lobster50,
                pressed: static_colors_1.default.lobster100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        accentOne: {
            heavy: {
                default: static_colors_1.default.domainGreen800,
                hover: static_colors_1.default.domainGreen900,
                pressed: static_colors_1.default.domainGreen900,
                selected: static_colors_1.default.domainGreen900,
                disabled: static_colors_1.default.coolGrey300,
            },
            medium: {
                default: static_colors_1.default.domainGreen600,
                hover: static_colors_1.default.domainGreen700,
                pressed: static_colors_1.default.domainGreen800,
                selected: static_colors_1.default.domainGreen900,
                disabled: static_colors_1.default.coolGrey300,
            },
            base: {
                default: static_colors_1.default.domainGreen500,
                hover: static_colors_1.default.domainGreen600,
                pressed: static_colors_1.default.domainGreen700,
                selected: static_colors_1.default.domainGreen900,
                disabled: static_colors_1.default.coolGrey300,
            },
            trim: {
                default: static_colors_1.default.domainGreen300,
                hover: static_colors_1.default.domainGreen400,
                pressed: static_colors_1.default.domainGreen500,
                selected: static_colors_1.default.domainGreen700,
                disabled: static_colors_1.default.coolGrey300,
            },
            subdued: {
                default: static_colors_1.default.domainGreen50,
                hover: static_colors_1.default.domainGreen100,
                pressed: static_colors_1.default.domainGreen200,
                selected: static_colors_1.default.domainGreen50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.domainGreen50,
                pressed: static_colors_1.default.domainGreen100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        accentTwo: {
            heavy: {
                default: static_colors_1.default.lavender800,
                hover: static_colors_1.default.lavender900,
                pressed: static_colors_1.default.lavender900,
                selected: static_colors_1.default.lavender900,
                disabled: static_colors_1.default.coolGrey300,
            },
            medium: {
                default: static_colors_1.default.lavender600,
                hover: static_colors_1.default.lavender700,
                pressed: static_colors_1.default.lavender800,
                selected: static_colors_1.default.lavender900,
                disabled: static_colors_1.default.coolGrey300,
            },
            base: {
                default: static_colors_1.default.lavender500,
                hover: static_colors_1.default.lavender600,
                pressed: static_colors_1.default.lavender700,
                selected: static_colors_1.default.lavender900,
                disabled: static_colors_1.default.coolGrey300,
            },
            trim: {
                default: static_colors_1.default.lavender300,
                hover: static_colors_1.default.lavender400,
                pressed: static_colors_1.default.lavender500,
                selected: static_colors_1.default.lavender700,
                disabled: static_colors_1.default.coolGrey300,
            },
            subdued: {
                default: static_colors_1.default.lavender50,
                hover: static_colors_1.default.lavender100,
                pressed: static_colors_1.default.lavender200,
                selected: static_colors_1.default.lavender50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.lavender50,
                pressed: static_colors_1.default.lavender100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        accentThree: {
            heavy: {
                default: static_colors_1.default.canary800,
                hover: static_colors_1.default.canary900,
                pressed: static_colors_1.default.canary900,
                selected: static_colors_1.default.canary900,
                disabled: static_colors_1.default.canary800,
            },
            medium: {
                default: static_colors_1.default.canary600,
                hover: static_colors_1.default.canary700,
                pressed: static_colors_1.default.canary800,
                selected: static_colors_1.default.canary900,
                disabled: static_colors_1.default.coolGrey300,
            },
            base: {
                default: static_colors_1.default.canary500,
                hover: static_colors_1.default.canary600,
                pressed: static_colors_1.default.canary700,
                selected: static_colors_1.default.canary900,
                disabled: static_colors_1.default.coolGrey300,
            },
            trim: {
                default: static_colors_1.default.canary300,
                hover: static_colors_1.default.canary400,
                pressed: static_colors_1.default.canary500,
                selected: static_colors_1.default.canary700,
                disabled: static_colors_1.default.coolGrey300,
            },
            subdued: {
                default: static_colors_1.default.canary50,
                hover: static_colors_1.default.canary100,
                pressed: static_colors_1.default.canary200,
                selected: static_colors_1.default.canary50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.canary50,
                pressed: static_colors_1.default.canary100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        accentFour: {
            heavy: {
                default: static_colors_1.default.ocean800,
                hover: static_colors_1.default.ocean900,
                pressed: static_colors_1.default.ocean900,
                selected: static_colors_1.default.ocean900,
                disabled: static_colors_1.default.coolGrey300,
            },
            medium: {
                default: static_colors_1.default.ocean600,
                hover: static_colors_1.default.ocean700,
                pressed: static_colors_1.default.ocean800,
                selected: static_colors_1.default.ocean900,
                disabled: static_colors_1.default.coolGrey300,
            },
            base: {
                default: static_colors_1.default.ocean500,
                hover: static_colors_1.default.ocean600,
                pressed: static_colors_1.default.ocean700,
                selected: static_colors_1.default.ocean900,
                disabled: static_colors_1.default.coolGrey300,
            },
            trim: {
                default: static_colors_1.default.ocean300,
                hover: static_colors_1.default.ocean400,
                pressed: static_colors_1.default.ocean500,
                selected: static_colors_1.default.ocean700,
                disabled: static_colors_1.default.coolGrey300,
            },
            subdued: {
                default: static_colors_1.default.ocean50,
                hover: static_colors_1.default.ocean100,
                pressed: static_colors_1.default.ocean200,
                selected: static_colors_1.default.ocean50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.ocean50,
                pressed: static_colors_1.default.ocean100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        accentFive: {
            heavy: {
                default: static_colors_1.default.sriracha800,
                hover: static_colors_1.default.sriracha900,
                pressed: static_colors_1.default.sriracha900,
                selected: static_colors_1.default.sriracha900,
                disabled: static_colors_1.default.coolGrey300,
            },
            medium: {
                default: static_colors_1.default.sriracha600,
                hover: static_colors_1.default.sriracha700,
                pressed: static_colors_1.default.sriracha800,
                selected: static_colors_1.default.sriracha900,
                disabled: static_colors_1.default.coolGrey300,
            },
            base: {
                default: static_colors_1.default.sriracha500,
                hover: static_colors_1.default.sriracha600,
                pressed: static_colors_1.default.sriracha700,
                selected: static_colors_1.default.sriracha900,
                disabled: static_colors_1.default.coolGrey300,
            },
            trim: {
                default: static_colors_1.default.sriracha300,
                hover: static_colors_1.default.sriracha400,
                pressed: static_colors_1.default.sriracha500,
                selected: static_colors_1.default.sriracha700,
                disabled: static_colors_1.default.coolGrey300,
            },
            subdued: {
                default: static_colors_1.default.sriracha50,
                hover: static_colors_1.default.sriracha100,
                pressed: static_colors_1.default.sriracha200,
                selected: static_colors_1.default.sriracha50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.sriracha50,
                pressed: static_colors_1.default.sriracha100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
    },
};
exports.default = output;
//# sourceMappingURL=pricefinder.js.map